import { momentNow, momentDate, biltyObjectFunction } from './Functions'
import { SegmentsEnum } from './Enums'
import moment from 'moment'

/* ============================================================================================== */
/* =================================== CREATE BILTY FUNCTIONS =================================== */
/* ============================================================================================== */

export const combinedOrdersFunction = ({ record, partialMatch = {}, movedUnits }) => {
	const combinedOrderIds = record?.map((order) => {
		const movedCount = parseInt(Math.round(partialMatch[order?.ChildId]?.movedCount))
		const totalCount = parseInt(Math.round(partialMatch[order?.ChildId]?.totalCount))

		return {
			ChildId: order?.ChildId,
			ParentId: order?.ParentId,
			subMovementType: order?.subMovementType,
			partialMatch: order?.totalCount ? order?.totalCount !== movedCount : !!partialMatch[order?.ChildId] && movedCount !== totalCount,
			movedUnits: movedUnits,
			movedCount: movedCount || null,
			totalCount: totalCount || null,
		}
	})
	const totalChildOrders = record?.length
	const combinedOrdersType = record?.map((order) => order?.type).pop()
	const combinedOrdersMovmentType = [...new Set(record?.map((order) => order?.movementType))]
	const combinedMovementType = combinedOrdersMovmentType?.includes('ImportShifting')
		? 'ImportShifting'
		: combinedOrdersMovmentType?.includes('DoubleTwenty')
		? 'DoubleTwenty'
		: combinedOrdersMovmentType?.includes('Import') && totalChildOrders === 2
		? 'DoubleTwenty'
		: combinedOrdersMovmentType?.[0]

	return { OrderIds: combinedOrderIds, type: combinedOrdersType, movementType: combinedMovementType }
}

export const prepareCreateBilty = (props) => {
	const { user, values, record, trackers, segment } = props
	const { OrderIds, type, movementType } = combinedOrdersFunction({
		record: Object?.values(record)?.flat(),
		partialMatch: values?.partialMatch,
		movedUnits: values?.movedUnits,
	})

	const trackerId = values?.trackerId
	const initial = SegmentsEnum[type]?.initial
	const trackerComment = values?.trackerComment
	const trackerAvailable = values?.trackerAvailable
	const trackerName = trackers?.find((tracker) => tracker?.key === trackerId)?.value

	const driverCNICDocument = values.driverCNICDocument?.length > 0 && values.driverCNICDocument?.map((document) => document?.url)
	const gatePassDocument = values.gatePassDocument?.length > 0 && values.gatePassDocument?.map((document) => document?.url)
	const initialEirDocument = values.initialEirDocument?.length > 0 && values.initialEirDocument?.map((document) => document?.url)
	const croDocument = values.croDocument?.length > 0 && values.croDocument?.map((document) => document?.url)

	const driver = {
		name: values?.driverName,
		phoneNumber: '+92' + values?.driverPhone?.split(' ')?.join(''),
		vehicleRegistrationNumber: values?.driverVehicleRegistration?.toLowerCase(),
		vehicleType: values?.vehicleType,
		cnic: values?.driverCNIC,
		...(driverCNICDocument && { cnicDocument: driverCNICDocument }),
	}

	const bilty = Object?.keys(record)?.map((document) => {
		let biltyPdfUrl = []
		if (values?.biltyType === 'manual') {
			biltyPdfUrl = values?.[document]?.halfDoneBiltyDocument?.length > 0 && values?.[document]?.halfDoneBiltyDocument?.map((document) => document?.url)
		}
		const initialKantaDocument =
			values?.[document]?.initialKantaDocument?.length > 0 && values?.[document]?.initialKantaDocument?.map((document) => document?.url)
		return {
			...(values?.[document]?.biltyNumber && { biltyNumber: values?.[document]?.biltyNumber }),
			...(values?.lcNumber && { lcNumber: values?.lcNumber }),
			...(values?.seal && { seal: values?.seal }),
			...(values?.munshiana && { munshiana: parseInt(values?.munshiana) }),
			...(values?.[document]?.initialKantaWeight && { initialKantaWeight: parseInt(values?.[document]?.initialKantaWeight) }),
			...(values?.[document]?.initialKantaCharges && { initialKantaCharges: parseInt(values?.[document]?.initialKantaCharges) }),

			...(initialKantaDocument && { initialKantaDocument: initialKantaDocument }),
			...(values?.numberOfBales && { numberOfBales: parseInt(values?.numberOfBales) }),

			...(initialEirDocument && { initialEirDocument: initialEirDocument }),
			...(croDocument && { croDocument: croDocument }),
			...(gatePassDocument && { gatePassDocument: gatePassDocument }),
			...(values?.remarks && { remarks: values.remarks.split('\n').join('^^') }),
			...(biltyPdfUrl.length > 0 && { halfDoneBiltyDocument: biltyPdfUrl }),
			...(['Import', 'Export']?.includes(segment) && { documentNumber: document }),
			isCancelled: false,
			biltySource: 'Web - Bilty Portal',
			biltyType: values?.biltyType,
			isInformationComplete: false,
			biltyCreatedAt: momentNow('x'),
			biltyCreatedBy: user?._id,
		}
	})

	let job = {
		OrderIds,
		bilty: bilty,
		movementType,
		driver,
		...(trackerAvailable === 'available' && trackerId && { TrackerId: trackerId }),
		...(trackerAvailable === 'notAvailable' && trackerComment && { trackerComment }),
	}
	return { job, bilty, initial, trackerName, trackerId, driver }
}

export const prepareLotCreateBilty = (props) => {
	const { user, values, record, trackers, segment } = props

	const trackerId = values?.trackerId
	const initial = SegmentsEnum[segment]?.initial
	const trackerComment = values?.trackerComment
	const trackerAvailable = values?.trackerAvailable
	const trackerName = trackers?.find((tracker) => tracker?.key === trackerId)?.value

	const driverCNICDocument = values.driverCNICDocument?.length > 0 && values.driverCNICDocument?.map((document) => document?.url)
	const gatePassDocument = values.gatePassDocument?.length > 0 && values.gatePassDocument?.map((document) => document?.url)
	const initialEirDocument = values.initialEirDocument?.length > 0 && values.initialEirDocument?.map((document) => document?.url)
	const croDocument = values.croDocument?.length > 0 && values.croDocument?.map((document) => document?.url)

	const driver = {
		name: values?.driverName,
		phoneNumber: '+92' + values?.driverPhone?.split(' ')?.join(''),
		vehicleRegistrationNumber: values?.driverVehicleRegistration?.toLowerCase(),
		cnic: values?.driverCNIC,
		...(driverCNICDocument && { cnicDocument: driverCNICDocument }),
	}

	const bilties = record?.bilty?.map((bilty) => {
		let biltyPdfUrl = []
		if (values?.biltyType === 'manual') {
			biltyPdfUrl = values?.undefined?.halfDoneBiltyDocument?.length > 0 ? values?.undefined?.halfDoneBiltyDocument?.map((document) => document?.url) : []
		}

		const initialKantaDocument =
			values?.undefined?.initialKantaDocument?.length > 0 ? values?.undefined?.initialKantaDocument?.map((document) => document?.url) : []
		return {
			_id: bilty?._id,
			...(values?.undefined?.biltyNumber && { biltyNumber: values?.undefined?.biltyNumber }),
			...(values?.lcNumber && { lcNumber: values?.lcNumber }),
			...(values?.seal && { seal: values?.seal }),
			...(values?.munshiana && { munshiana: parseInt(values?.munshiana) }),
			...(values?.undefined?.initialKantaWeight && { initialKantaWeight: parseInt(values?.undefined?.initialKantaWeight) }),
			...(values?.undefined?.initialKantaCharges && { initialKantaCharges: parseInt(values?.undefined?.initialKantaCharges) }),

			...(initialKantaDocument && { initialKantaDocument: initialKantaDocument }),
			...(values?.numberOfBales && { numberOfBales: parseInt(values?.numberOfBales) }),

			...(initialEirDocument && { initialEirDocument: initialEirDocument }),
			...(croDocument && { croDocument: croDocument }),
			...(gatePassDocument && { gatePassDocument: gatePassDocument }),
			...(values?.remarks && { remarks: values.remarks.split('\n').join('^^') }),
			...(biltyPdfUrl.length > 0 && { halfDoneBiltyDocument: biltyPdfUrl }),
			...(['Import', 'Export']?.includes(segment) && { documentNumber: document }),
			isCancelled: false,
			biltySource: 'Web - Bilty Portal',
			biltyType: values?.biltyType,
			isInformationComplete: false,
			biltyCreatedAt: momentNow('x'),
			biltyCreatedBy: user?._id,
		}
	})
	return {
		bilties,
		initial,
		trackerName,
		trackerId,
		driver,
		...(trackerAvailable === 'available' && trackerId && { TrackerId: trackerId }),
		...(trackerAvailable === 'notAvailable' && trackerComment && { trackerComment }),
	}
}

/* ============================================================================================== */
/* ================================= COMPLETE BILTY FUNCTIONS =================================== */
/* ============================================================================================== */

export const setFieldsCompleteBilty = (props) => {
	const {
		data: { record },
	} = props
	const vehicle = record?.Vehicle
	const driver = record?.Driver
	return {
		driverName: driver?.name,
		driverPhone: driver?.phoneNumber && (driver?.phoneNumber?.includes('+92') ? driver?.phoneNumber?.replace('+92', '') : driver?.phoneNumber),
		driverVehicleRegistration: vehicle?.registrationNumber?.toLowerCase(),
		driverCNIC: driver?.cnic,
		driverCNICDocument: driver?.cnicDocument?.map((doc, index) => {
			return { uid: `${index + 1}`, name: `driverCNICDocument`, status: 'done', url: doc }
		}),
	}
}

export const prepareCompleteBilty = (props) => {
	const { user, values, record } = props
	const loloDocument = values?.loloDocument && values.loloDocument?.length > 0 && values.loloDocument?.map((document) => document?.url)
	const amanatUpload = values?.amanatUpload && values.amanatUpload?.length > 0 && values.amanatUpload?.map((document) => document?.url)
	const offLoadingUpload = values?.offLoadingUpload && values.offLoadingUpload?.length > 0 && values.offLoadingUpload?.map((document) => document?.url)
	const rotationalReceipt =
		values?.rotationalReceipt && values?.rotationalReceipt?.length > 0 && values.rotationalReceipt?.map((document) => document?.url)

	return record?.bilty?.map((bilty) => {
		const biltyDocument =
			values?.[bilty?.biltyNumber]?.biltyDocument?.length > 0 && values?.[bilty?.biltyNumber]?.biltyDocument?.map((document) => document?.url)
		const kantaDocument =
			values?.[bilty?.biltyNumber]?.kantaDocument?.length > 0 && values?.[bilty?.biltyNumber]?.kantaDocument?.map((document) => document?.url)
		const eirDocument =
			values?.[bilty?.biltyNumber]?.eirDocument?.length > 0 && values?.[bilty?.biltyNumber]?.eirDocument?.map((document) => document?.url)

		return {
			_id: bilty?._id,
			biltyDocument: biltyDocument,
			...(eirDocument && { eirDocument: eirDocument }),
			...(amanatUpload && { amanatUpload: amanatUpload }),
			...(loloDocument && { loloDocument: loloDocument }),
			...(kantaDocument && { kantaDocument: kantaDocument }),
			...(offLoadingUpload && { offLoadingUpload: offLoadingUpload }),
			...(rotationalReceipt && { rotationalReceipt: rotationalReceipt }),
			...(values?.[bilty?.biltyNumber]?.kantaWeight && { kantaWeight: parseInt(values?.[bilty?.biltyNumber]?.kantaWeight) }),
			...(values?.[bilty?.biltyNumber]?.kantaCharges && { kantaCharges: parseInt(values?.[bilty?.biltyNumber]?.kantaCharges) }),
			...(values?.loloCharges && { loloCharges: parseInt(values?.loloCharges) }),
			...(values?.placementCharges && { placementCharges: parseInt(values?.placementCharges) }),
			...(values?.rotationalCharges && { rotationalCharges: parseInt(values?.rotationalCharges) }),
			...(values?.amanat && { amanat: parseInt(values?.amanat) }),
			...(values?.offLoadingCharges && { offLoadingCharges: parseInt(values?.offLoadingCharges) }),
			...(values?.repairingCharges && { repairingCharges: parseInt(values?.repairingCharges) }),
			...(values?.gateIn && { gateIn: momentDate(values?.gateIn, 'x') }),
			...(values?.gateOut && { gateOut: momentDate(values?.gateOut, 'x') }),
			biltyStatus: 'received',
			biltyCompletedAt: momentNow('x'),
			biltyCompletedBy: user?._id,
			isInformationComplete: true,
		}
	})
}

/* ============================================================================================== */
/* =================================== EDIT BILTY FUNCTIONS ===================================== */
/* ============================================================================================== */

export const setFieldsEditBilty = (props) => {
	const {
		data: { record },
	} = props
	const bilty = record?.bilty
	const biltyDataObject = biltyObjectFunction(record?.bilty)
	return {
		...Object?.keys(biltyDataObject)?.reduce((bilties, biltyNumber) => {
			return {
				...bilties,
				[biltyNumber]: {
					biltyDocument: biltyDataObject?.[biltyNumber]?.biltyDocument?.map((doc, index) => {
						return { uid: `${index + 1}`, name: `biltyDocument`, status: 'done', url: doc }
					}),
					eirDocument: biltyDataObject?.[biltyNumber]?.eirDocument?.map((doc, index) => {
						return { uid: `${index + 1}`, name: `eirDocument`, status: 'done', url: doc }
					}),

					kantaWeight: biltyDataObject?.[biltyNumber]?.kantaWeight,
					kantaCharges: biltyDataObject?.[biltyNumber]?.kantaCharges,
					kantaDocument: biltyDataObject?.[biltyNumber]?.kantaDocument?.map((doc, index) => {
						return { uid: `${index + 1}`, name: `kantaDocument`, status: 'done', url: doc }
					}),
				},
			}
		}, {}),
		loloCharges: bilty?.[0]?.loloCharges,
		loloDocument: bilty?.[0]?.loloDocument?.map((doc, index) => {
			return { uid: `${index + 1}`, name: `loloDocument`, status: 'done', url: doc }
		}),
		placementCharges: bilty?.[0]?.placementCharges,
		rotationalCharges: bilty?.[0]?.rotationalCharges,
		rotationalReceipt: bilty?.[0]?.rotationalReceipt?.map((doc, index) => {
			return { uid: `${index + 1}`, name: `rotationalReceipt`, status: 'done', url: doc }
		}),
		amanat: bilty?.[0]?.amanat,
		amanatUpload:
			bilty?.[0]?.amanatUpload?.map((doc, index) => {
				return { uid: `${index + 1}`, name: `amanatUpload`, status: 'done', url: doc }
			}) || [],
		offLoadingCharges: bilty?.[0]?.offLoadingCharges,
		offLoadingUpload:
			bilty?.[0]?.offLoadingUpload?.map((doc, index) => {
				return { uid: `${index + 1}`, name: `offLoadingUpload`, status: 'done', url: doc }
			}) || [],
		repairingCharges: bilty?.[0]?.repairingCharges,
		gateIn: bilty?.[0]?.gateIn && moment(bilty?.[0]?.gateIn, 'x'),
		gateOut: bilty?.[0]?.gateOut && moment(bilty?.[0]?.gateOut, 'x'),
	}
}

export const prepareEditBilty = (props) => {
	const { record, values } = props
	const loloDocument = values?.loloDocument && values.loloDocument?.length > 0 && values.loloDocument?.map((document) => document?.url)
	const amanatUpload = values?.amanatUpload && values.amanatUpload?.length > 0 && values.amanatUpload?.map((document) => document?.url)
	const offLoadingUpload = values?.offLoadingUpload && values.offLoadingUpload?.length > 0 && values.offLoadingUpload?.map((document) => document?.url)
	const rotationalReceipt =
		values?.rotationalReceipt && values?.rotationalReceipt?.length > 0 && values.rotationalReceipt?.map((document) => document?.url)

	return record?.bilty?.map((bilty) => {
		const biltyDocument =
			values?.[bilty?.biltyNumber]?.biltyDocument?.length > 0 && values?.[bilty?.biltyNumber]?.biltyDocument?.map((document) => document?.url)
		const kantaDocument =
			values?.[bilty?.biltyNumber]?.kantaDocument?.length > 0 && values?.[bilty?.biltyNumber]?.kantaDocument?.map((document) => document?.url)

		const eirDocument =
			values?.[bilty?.biltyNumber]?.eirDocument?.length > 0 && values?.[bilty?.biltyNumber]?.eirDocument?.map((document) => document?.url)
		return {
			_id: bilty?._id,
			biltyDocument: biltyDocument,
			eirDocument: eirDocument || [],
			amanatUpload: amanatUpload || [],
			loloDocument: loloDocument || [],
			kantaDocument: kantaDocument || [],
			offLoadingUpload: offLoadingUpload || [],
			rotationalReceipt: rotationalReceipt || [],
			...(values?.[bilty?.biltyNumber]?.kantaWeight && { kantaWeight: parseInt(values?.[bilty?.biltyNumber]?.kantaWeight) }),
			...(values?.[bilty?.biltyNumber]?.kantaCharges && { kantaCharges: parseInt(values?.[bilty?.biltyNumber]?.kantaCharges) }),
			...(values?.loloCharges && { loloCharges: parseInt(values?.loloCharges) }),
			...(values?.placementCharges && { placementCharges: parseInt(values?.placementCharges) }),
			...(values?.rotationalCharges && { rotationalCharges: parseInt(values?.rotationalCharges) }),
			...(values?.amanat && { amanat: parseInt(values?.amanat) }),
			...(values?.offLoadingCharges && { offLoadingCharges: parseInt(values?.offLoadingCharges) }),
			...(values?.repairingCharges && { repairingCharges: parseInt(values?.repairingCharges) }),
			...(values?.gateIn && { gateIn: momentDate(values?.gateIn, 'x') }),
			...(values?.gateOut && { gateOut: momentDate(values?.gateOut, 'x') }),
		}
	})
}

/* ============================================================================================== */
/* ================================== CANCEL BILTY FUNCTIONS ==================================== */
/* ============================================================================================== */

export const prepareCancelBilty = (props) => {
	const { user, record, values } = props
	return record?.bilty?.map((bilty) => ({
		_id: bilty?._id,
		biltyCancelledAt: momentNow('x'),
		biltyCancelledBy: user?._id,
		biltyCancelReason: values?.cancelReason,
		isCancelled: true,
	}))
}

/* ============================================================================================== */
/* ============================= ADD MISSING KANTA FUNCTIONS ==================================== */
/* ============================================================================================== */

export const setFieldsAddMissingKanta = (props) => {
	const { record } = props
	const biltyDataObject = biltyObjectFunction(record?.bilty)
	return {
		...Object?.keys(biltyDataObject)?.reduce((bilties, biltyNumber) => {
			return {
				...bilties,
				[biltyNumber]: {
					initialKantaWeight: biltyDataObject?.[biltyNumber]?.initialKantaWeight,
					initialKantaCharges: biltyDataObject?.[biltyNumber]?.initialKantaCharges,
					initialKantaDocument: biltyDataObject?.[biltyNumber]?.initialKantaDocument?.map((doc, index) => {
						return { uid: `${index + 1}`, name: `initialKantaDocument`, status: 'done', url: doc }
					}),
				},
			}
		}, {}),
	}
}

export const prepareMissingKantaBilty = (props) => {
	const { record, values } = props

	return record?.bilty?.map((bilty) => {
		const initialKantaDocument =
			values?.[bilty?.biltyNumber]?.initialKantaDocument?.length > 0 && values?.[bilty?.biltyNumber]?.initialKantaDocument?.map((document) => document?.url)
		return {
			_id: bilty?._id,
			...(values?.[bilty?.biltyNumber]?.initialKantaWeight && { initialKantaWeight: parseInt(values?.[bilty?.biltyNumber]?.initialKantaWeight) }),
			...(values?.[bilty?.biltyNumber]?.initialKantaCharges && { initialKantaCharges: parseInt(values?.[bilty?.biltyNumber]?.initialKantaCharges) }),
			initialKantaDocument: initialKantaDocument || [],
		}
	})
}
